import { asyncAction } from 'lib/actionCreators'

export const inviteOtherRecruiter = asyncAction('manager/INVITE_OTHER_RECRUITER')
export const declineOtherRecruiter = asyncAction('manager/DECLINE_OTHER_RECRUITER')
export const acceptOtherRecruiter = asyncAction('manager/ACCEPT_OTHER_RECRUITER')
export const closeOtherRecruiter = asyncAction('manager/CLOSE_OTHER_RECRUITER')
